import React, { Component } from 'react';
import {connect} from 'react-redux';
import {login} from '../../../config/redux/actions/securityActions';
import { GetLogin2,GetUserPermissions} from '../../../services/SecurityService';
import CardLogin from '../../components/CardLogin2';
import COLORS from '../../resources/colors/ColorsApp';
import { Button } from '@material-ui/core';

class LoginPages2 extends Component {
    constructor(props){
        super(props);

        console.log("Estas en Login 2")
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(){
        console.log("Estas en Login 2");
        let data = {username: this.props.match.params.username , password : this.props.match.params.password, consulta : 1}


           
                    

          
 


           
    }
    handleSubmit(email, password, afterSubmit){
      
let data = {username: email , password : password, consulta : 1}


             

           
   
    }

    render() {    
        return (
            
            <div style={styles.mainContainer}>
                

            {
             //   <img src={require("../../resources/images/tec-logo.png")} height={140} width={431}/>
        }
                <CardLogin onSubmit={this.handleSubmit}
                username={this.props.match.params.username}
                password={this.props.match.params.password}
                />
                
            </div>
        );
    }
}

const styles = {
  
};

const mapStateToProps = (state, props) => {
    return {
      users: state.security,
    };
}
const mapDispatchToProps = {
    login
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginPages2)